import {
  WORKFLOW_METADATA_SET_LOADING,
  WORKFLOW_METADATA_SET_DATA,
  WORKFLOW_METADATA_SET_ERROR,
  WORKFLOW_METADATA_CLEAR_EVENTS,
} from './constants';
import { getWorkFlowBuilderMetaData } from 'src/api/workFlowBuilder';

export const clearEventMetadata = (objectType: string) => ({
  type: WORKFLOW_METADATA_CLEAR_EVENTS,
  data: { objectType },
});

export const fetchObjectFieldListMetadata = (params) => async (dispatch, getState) => {
  const { jsonArrayTableViewReducer } = getState();

  const eventMeta = jsonArrayTableViewReducer?.eventMetadata?.[params.objectType];

  if (
    jsonArrayTableViewReducer?.isLoading ||
    (jsonArrayTableViewReducer?.fieldListMetadata?.[params.objectType] && eventMeta)
  ) {
    return;
  }

  dispatch({
    type: WORKFLOW_METADATA_SET_LOADING,
    data: true,
  });

  const response = await getWorkFlowBuilderMetaData(params);
  if (response.isSuccess) {
    dispatch({
      type: WORKFLOW_METADATA_SET_DATA,
      data: {
        fieldListMetadata: {
          [params.objectType]: response?.data?.field_list || [],
        },
        eventMetadata: {
          [params.objectType]: response?.data?.events || [],
        },
      },
    });
  } else {
    dispatch({
      type: WORKFLOW_METADATA_SET_ERROR,
      data: response.errorMessage,
    });
  }

  dispatch({
    type: WORKFLOW_METADATA_SET_LOADING,
    data: false,
  });
};
